import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EntData, EntDescription } from '@bazis/shared/models/srv.types';

export type FormEvent = {
    type: 'created' | 'updated' | 'removed' | 'structureUpdated';
    entityDescription: EntDescription;
    entity?: EntData;
    data?: any;
};

@Injectable({
    providedIn: 'root',
})
export class FormEventService {
    formEvent$: BehaviorSubject<FormEvent> = new BehaviorSubject(null);
}
